import { render, staticRenderFns } from "./TokenDetails.vue?vue&type=template&id=474cdadf&scoped=true"
import script from "./TokenDetails.vue?vue&type=script&lang=js"
export * from "./TokenDetails.vue?vue&type=script&lang=js"
import style0 from "./TokenDetails.vue?vue&type=style&index=0&id=474cdadf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474cdadf",
  null
  
)

export default component.exports